/**
* @description: 用户建议反馈管理
*/
<template>
    <div class="finance_box" ref="myElementRef">
        <div ref="searchBox">
            <hc-search :data="searchData" @serch="getSearch" />
        </div>
        <!-- 表格 -->
        <div class="table_box">
            <hc-table :tableData="state.tableData" :column="state.tableHeader" :offsetHeight="state.offsetHeight" :maxPage="maxPage"
                @pageChange="pageChange" @limitChange="limitChange">
                <template #type="{ row }">
                    {{ listToMap(typeOptions, {})[row.type] }}
                </template>
                <template #status="{ row }">
                    <el-tag :type="statusTypeMap[row.status]" size="small">{{ listToMap(statusOptions, {})[row.status] }}</el-tag>
                </template>
                <template #operation="{ row }">
                    <el-button v-if="row.status == 0" class="opBtn" size="small" type="primary" link
                        @click="openReply(row)">{{ t('feedbackList.reply') }}</el-button>
                </template>
            </hc-table>
        </div>
        <!-- 新增 -->
        <Reply ref="reply" :title="state.title" :row="state.row" :typeOptions="typeOptions" :statusOptions="statusOptions" @refresh="getSearch(searchData)" />
    </div>
</template>

<script setup>
import hcSearch from "@/components/hc-search/index.vue";
import hcTable from "@/components/hc-table/index.vue";
import { onMounted, reactive, ref, nextTick, onUnmounted, onActivated, toRaw } from "vue";
import Reply from "./reply.vue";

import { pageListApi } from "@/api/feedback";
import { pageListApi as userListApi } from "@/api/system/personnel";
import { listToMap } from "@/utils/utils";
import { usePageI18n } from "@/composables/usePageI18n.js";
import { applySearchLabels, applyColumnLabels, applyOptionLabels } from "@/utils/listPageI18n.js";

const FEEDBACK_COLUMNS = {
  id: "feedbackList.colId",
  title: "feedbackList.colTitle",
  status: "feedbackList.colStatus",
  type: "feedbackList.colType",
  real_name: "feedbackList.colReporter",
  content: "feedbackList.colContent",
  contact_info: "feedbackList.colContact",
  created_at: "feedbackList.colCreatedAt",
  operation: "common.operation",
};

const myElementRef = ref();
const searchBox = ref();
const reply = ref();


let page = ref(1);
let limit = ref(20);
let maxPage = ref(0);
const statusOptions = reactive([
    { label: "已处理", value: 1 },
    { label: "待处理", value: 0 },
    { label: "全部", value: 99 },
])
const statusTypeMap = {
    0: 'danger',
    1: 'success',
}

const typeOptions = reactive([
    { label: "功能建议", value: 1 },
    { label: "BUG反馈", value: 2 },
    { label: "使用问题", value:3 },
    { label: "其他", value: 4 },
])

const getUserList = () => {
    const params = JSON.stringify({
        "page": 1,
        "limit": 9999,
        "keywords": "",
        "role_id": 0,
        "status": 99
    })
    userListApi(params).then(res => {
        searchData[4].children = res.data.map(i => {
            return { label: i.real_name, value: i.real_name }
        })
        getSearch(searchData)
    })
}

const searchData = reactive([
    {
        label: "标题关键字",
        type: "input",
        value: "",
        field: 'keywords'
    },
    {
        label: "标题",
        type: "input",
        value: "",
        field: 'title',
    },
    {
        label: "类型",
        type: "select",
        value: "",
        field: 'type',
        children: typeOptions
    },
    {
        label: "状态",
        type: "select",
        value: 99,
        defaultValue: 99,
        field: 'status',
        children: statusOptions,
        clearable: false
    },
    {
        label: "反馈人",
        type: "select",
        value: '',
        field: 'real_name',
        children: []
    },
]);

const state = reactive({
    title: "",
    column: [
        {
            prop: "id",
            show: false,
            label: "反馈ID",
        },
        {
            // prop: "id",
            show: true,
            type: "index",
            label: "序号",
            width: 80,
        },
        {
            prop: "title",
            show: true,
            label: "标题",
        },
        {
            prop: "status",
            show: true,
            label: "状态",
        },
        {
            prop: "type",
            show: true,
            label: "类型",
        },
        {
            prop: "real_name",
            show: true,
            label: "反馈人",
        },
        {
            prop: "content",
            show: true,
            label: "意见内容",
        },
        {
            prop: "contact_info",
            show: true,
            label: "联系方式",
        },
        {
            prop: "created_at",
            show: true,
            label: "创建时间",
        },
        {
            prop: "operation",
            show: true,
            label: "操作",
        },
    ],
    offsetHeight: 0,
    tableHeader: [],
    tableData: [

    ],
    row: {}
});

const applyLabels = () => {
  applySearchLabels(searchData, {
    keywords: { labelKey: "feedbackList.keywordLabel" },
    title: { labelKey: "feedbackList.titleLabel" },
    type: { labelKey: "feedbackList.typeLabel" },
    status: { labelKey: "feedbackList.statusLabel" },
    real_name: { labelKey: "feedbackList.reporterLabel" },
  });
  applyColumnLabels(state.column, FEEDBACK_COLUMNS);
  applyOptionLabels(statusOptions, {
    1: "feedbackList.statusDone",
    0: "feedbackList.statusPending",
    99: "common.all",
  });
  applyOptionLabels(typeOptions, {
    1: "feedbackList.typeSuggestion",
    2: "feedbackList.typeBug",
    3: "feedbackList.typeUsage",
    4: "feedbackList.typeOther",
  });
};
const { t } = usePageI18n(applyLabels);

const init = () => {
    getUserList()
};

// 动态改变表头
const change = (item) => {
    tableHeaderFn();
};

const offHeighths = () => {
    if (myElementRef.value) {
        state.offsetHeight =
            myElementRef.value?.offsetHeight - 90 - searchBox.value?.offsetHeight;
    }
};

const pageChange = (currentPage) => {

    page.value = currentPage;
    getSearch(searchData)
}

const limitChange = (currentLimit) => {

    limit.value = currentLimit;
    getSearch(searchData)
}

const openReply = (row) => {
    reply.value.open()
    state.row = row
};

onMounted(() => {
    try {
        nextTick(() => {
            offHeighths();
        });
        window.onresize = () => {
            nextTick(() => {
                offHeighths();
            });
        };
        applyLabels();
        tableHeaderFn();
        init();
    } catch { }
});

onUnmounted(() => {
    window.onresize = null;
});

// 查询过来的数据
const getSearch = (params) => {
    params.forEach(i => i.value = i.value || '')
    const form = listToMap(toRaw(params), { value: 'value', key: 'field' })
    console.log(237, form)
    const requestParams = {
        page: page.value,
        limit: limit.value,
        ...form
    }
    state.loading = true
		pageListApi(JSON.stringify(requestParams)).then(res => {
        maxPage.value = res?.maxPage ?? 0;
        state.tableData = res?.data?.map(item => {
            return {
                ...item,
                // status: listToMap(statusOptions, {})[item.status],
                // type: listToMap(typeOptions, {})[item.type],
            }
        }) ?? []
    }).finally(() => {
		state.loading = false
	})
};

// 表头筛选
const tableHeaderFn = () => {
    state.tableHeader = state.column.filter((v) => {
        if (v.show) {
            return v.show == true;
        } else {
            v.show = false;
        }
    });
};
</script>

<style lang="less" scoped>
.finance_box {
    flex: 1;
    overflow: auto;
    background-color: #fff;
    border-radius: 6px;
    padding: 10px;
    margin-right: 10px;
}

.btn_box {
    height: 40px;
    display: flex;
}

.table_box {
    width: 100%;
}

/deep/.el-button-group .el-button--primary:first-child {
    background-color: #1e6aed;
    border: none;
}

.serBtn {
    margin-left: 10px;
    background-color: #f0f0f0;
    color: #000;
    border: none;
}

.serBtn:hover {
    background-color: #f0f0f0;
    color: #000;
}

.opBtn {
    // margin: 0 !important;
    margin: 0 10px 0 0;
}

.opBtn:hover {
    color: #e6a755;
}
</style>
